export const filterByProperty = (arr: string[], assets: any[], property: string) => {
  return assets.filter((asset) => arr.includes(asset.properties[property]));
};
